import * as React from "react";
const SvgMoveUp = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><path fill="#000" d="M9.333 20v-8H4l8-8 8 8h-5.333v8z" /></svg>;
export { SvgMoveUp as ReactComponent };